// import Constants from '../common/Constants';

const AuthUtil = {
  isUserLogined: false,
  externLogined: false,
  isLogining: false,
  xiaomi_id: '',
  MainLogin: function (force, showLoginPage, cb) {
    if (!force && AuthUtil.isUserLogined) {
      if (cb) {
        cb(true);
      }
      return;
    }
    if (AuthUtil.isLogining) {
      if (cb) {
        cb(false);
      }
    }
  },

  externLogin: function (cb) {},

  LoginFromJS: function (sid, domain, cb) {},

  LoginByPassToken: function (sid, cb) {},

  clearLoginInfo: function () {},

  isLogined: function (url, cb) {
    // 因为服务端种的cookie是httponly 另外用cookie内的serviceToken也无法判断是否失效，所以暂时先改成初始化时获取的登录状态。
    return AuthUtil.isUserLogined;
  },
  jumpToLogin: function (navigator) {
    const client_id = '180100031051';

    location.href = `${location.protocol}//${
      location.host
    }/v1/authorize/sso?client_id=${client_id}&_snsNone=true&callback=${encodeURIComponent(location.href)}`;
    // location.href = `https://m.mi.com/v1/authorize/sso?client_id=${client_id}&_snsNone=true&callback=${encodeURIComponent(
    //   'https://m.mi.com',
    // )}`;
  },

  jumpToLoginIfNotLogin: function (navigator) {
    if (!AuthUtil.isLogined()) {
      setTimeout(() => {
        this.jumpToLogin(true, navigator);
      }, 200);
      return true;
    }
    return false;
  },

  SaveUserId: function (uid) {},
  async updateAuth(flag) {
    if (typeof flag === 'boolean') {
      AuthUtil.isUserLogined = flag;
      return;
    }

    try {
      // await request.fetchDataString(UPDATE_LOGIN_URL);
      const result = await window.checkIsLogin();
      console.log('check login', result);

      AuthUtil.isUserLogined = result;
    } catch (error) {
      // let result = error.response;
      // if (result && result.status === 401) {
      //   AuthManager.isUserLogined = false;
      // }
      AuthUtil.isUserLogined = false;
    }
  },
  isMianLoginEvent: (e) => {},
  userInfo: null,
  getUserInfo: async () => {
    if (AuthUtil.userInfo) {
      return AuthUtil.userInfo;
    }
    // 移除对客服url的获取，统一在info静态接口中获取
    /* fetch('/v1/service/common_cfg', {
      body: 'client_id=180100031051&webp=1&key=service_chat_url',
      method: 'post',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
      .then(async (response) => {
        const data = await response.json();
        if (data.code === 0 && data.data.m_product_detail) {
          window.m_mi = {};
          window.m_mi.m_product_detail = data.data.m_product_detail;
        }
      })
      .catch((e) => {}); */
    AuthUtil.userInfo = new Promise((resolve) => {
      fetch('/v1/user/index', {
        data: {
          client_id: '180100031051',
          channel_id: '',
          webp: 1,
          isLogin: false,
        },
        credentials: 'include',
      })
        .then(async (response) => {
          const data = await response.json();
          if (data.code === 0 && data.data.user.user_id) {
            AuthUtil.isUserLogined = true;
            AuthUtil.hasInited = true;
            resolve(data.data.user);
          } else {
            resolve({});
          }
        })
        .catch(() => {
          AuthUtil.userInfo = null;
          resolve(null);
        });
    });
    return AuthUtil.userInfo || {};
  },
  initAcountInfo: () => {},
};
// AuthUtil.isLogined;

module.exports = AuthUtil;
